module.exports = __webpack_public_path__ + "assets/img/1-1.2e3221b8.png";